import {Response, Model, ID} from '@/_metronic/helpers'
import {ProductAvailability} from '../../products/core/_models'

export type OpProduct = {
  product: ID;
  name: string;
  sp_name?: string;
  sp_sku?: string;
  amount: number;
  discount: number;
  vat: number;
  currency: string;
  qty: number;
  delivred: number;
  stock?: number;
  threshold?: number;
}

export type OpState = {
  state: string
  date: Date
}
export type SupplierOperation = Model & {
  supplier: ID;
  parent?: ID;
  childs?:[ID];
  supplierName?: string;
  reference?: string;
  po_number?: string;
  pay_ref?: string;
  states?: Array<OpState>
  type: string
  amount: number
  products?: Array<OpProduct>
  _config?: {
    states: Array<string>
  }
}

export type Supplier = Model & {
  name: string
  slug: string
  apiAvailable: boolean
  status: string
  country: string
  currency: string
  priceDigits: number
  vat: number
  contacts: string[]
  credentials?: {
    type: string
    email?: string
    password?: string
    apiKey?:string
    secretKey?:string
  }
  balance: number
}

export type SuppliersQueryResponse = Response<Array<Supplier>>
export type SupplierOperationsQueryResponse = Response<Array<SupplierOperation>>

export type RegistredProduct = Model & {
  name: string;
  brand: string;
  stock: number;
  threshold: number;
  availability: ProductAvailability
}

export type SupplierProduct = {
  name: string
  sku: string
  amount: number
}

export const initialSupplier: Supplier = {
  name: '',
  slug: '',
  apiAvailable: false,
  status: 'STATUS_DISABLED',
  currency: '',
  country: '',
  vat: 0,
  balance: 0,
  priceDigits: 3,
  contacts: []
}
